function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDownloadArrowLine = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.274 12.846",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "np_download_4434865_000000",
    transform: "matrix(1, 0, 0, 1, -8.332, -12.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5722",
    "data-name": "Path 5722",
    d: "M32.755,12.5a.714.714,0,0,0-.713.714v6.838L30.41,18.42a.714.714,0,1,0-1.01,1.01l2.817,2.817a.714.714,0,0,0,1.04.039.46.46,0,0,0,.042-.039l2.817-2.817a.714.714,0,0,0-1.009-1.01l-1.638,1.638V13.214a.714.714,0,0,0-.714-.714Z",
    transform: "translate(-17.287)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5723",
    "data-name": "Path 5723",
    d: "M9.046,79.168a.714.714,0,1,0,0,1.427H21.892a.714.714,0,1,0,0-1.427Z",
    transform: "translate(0 -55.249)",
    style: {}
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadArrowLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download-arrow-line.d2a789bf.svg";
export { ForwardRef as ReactComponent };